import { types } from './actions'

const INITIAL_STATE = {
  term: '',
}

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.SET_TERM:
      return {
        ...state,
        ...action.meta,
      }

    default:
      return state
  }
}
